import { createContext, useContext, ReactNode } from 'react';

interface RegionalSettingsContextType {
  locale: string;
  currency: string;
}

const RegionalSettingsContext = createContext<RegionalSettingsContextType>({
  locale: 'en-US',
  currency: 'USD',
});

interface RegionalSettingsProviderProps {
  children: ReactNode;
  locale?: string;
  currency?: string;
}

export function RegionalSettingsProvider({
  children,
  locale = 'en-US',
  currency = 'USD',
}: RegionalSettingsProviderProps) {
  return (
    <RegionalSettingsContext.Provider value={{ locale, currency }}>
      {children}
    </RegionalSettingsContext.Provider>
  );
}

export function useRegionalSettings() {
  return useContext(RegionalSettingsContext);
}
